import { useFetch } from "../../hooks/useFetch";
import LoadSimple from "../LoadSimple";
import Modal from "react-modal";
import ModalDeleteCis from "./ModalDeleteCis";
import { useState, useEffect } from "react";
import ModalCisAfecta from "./ModalCisAfecta";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
import Action from "../Action";
const deleteCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "30%",
    padding: "20px",
  },
};

const Instalaciones = ({
    buscar_cis_history,
    handleChangEdit,
    cisSelected,
    server,
    languaje,
    handleShowPopup,
    mode
}) => {
  // const dataUsers=useFetch('cassia/ci','',localStorage.getItem('access_token'),'GET',server)
  const dataApps=[
      {
        "id": 1,
        "name": "Google Chrome",
        "verify_path": [
          "C:\\Program Files (x86)\\Google\\Chrome",
          "C:\\Program Files\\Google\\Chrome"
        ],
        "install_endpoint": "/google/google-chrome/ws/install/",
        "uninstall_endpoint": "/google/google-chrome/ws/uninstall/",
        "status_endpoint": "/google/google-chrome/status/",
        "icon_name": "chrome.png",
        "operating_system_id": 1,
        "softwarekey": "windows10GoogleChrome",
        "status": "installing"
      },
      {
        "id": 2,
        "name": "AnyDesk",
        "verify_path": [
          "C:\\Program Files (x86)\\AnyDeskMSI",
          "C:\\Program Files\\AnyDeskMSI"
        ],
        "install_endpoint": "/anydesk/anydesk/ws/install/",
        "uninstall_endpoint": "/anydesk/anydesk/ws/uninstall/",
        "status_endpoint": "/anydesk/anydesk/status/",
        "icon_name": "anydesk.png",
        "operating_system_id": 1,
        "softwarekey": "windows10Anydesk",
        "status": "uninstalling"
      },
      {
        "id": 3,
        "name": "Mobatek",
        "verify_path": [
          "C:\\Program Files (x86)\\Mobatek",
          "C:\\Program Files\\Mobatek"
        ],
        "install_endpoint": "/mobatek/mobatek/ws/install/",
        "uninstall_endpoint": "/mobatek/mobatek/ws/uninstall/",
        "status_endpoint": "/mobatek/mobatek/status/",
        "icon_name": "mobatek.png",
        "operating_system_id": 1,
        "softwarekey": "windows10Mobateck",
        "status": "installed"
      },
      {
        "id": 4,
        "name": "Zoom",
        "verify_path": [
          "C:\\Program Files (x86)\\Zoom",
          "C:\\Program Files\\Zoom"
        ],
        "install_endpoint": "/zoom/zoom/ws/install/",
        "uninstall_endpoint": "/zoom/zoom/ws/uninstall/",
        "status_endpoint": "/zoom/zoom/status/",
        "icon_name": "zoom.png",
        "operating_system_id": 1,
        "softwarekey": "windows10Zoom",
        "status": "not_installed"
      },
      {
        "id": 5,
        "name": "FortiClientVPN",
        "verify_path": [
          "C:\\Program Files (x86)\\Fortinet\\FortiClient",
          "C:\\Program Files\\Fortinet\\FortiClient"
        ],
        "install_endpoint": "/forticlientvpn/forticlientvpn/ws/install/",
        "uninstall_endpoint": "/forticlientvpn/forticlientvpn/ws/uninstall/",
        "status_endpoint": "/forticlientvpn/forticlientvpn/status/",
        "icon_name": "forticlientvpn.png",
        "operating_system_id": 1,
        "softwarekey": "windows10FortiClient",
        "status": "unknown"
      },
      {
        "id": 6,
        "name": "Firefox",
        "verify_path": [
          "C:\\Program Files (x86)\\Mozilla Firefox",
          "C:\\Program Files\\Mozilla Firefox"
        ],
        "install_endpoint": "/firefox/firefox/ws/install/",
        "uninstall_endpoint": "/firefox/firefox/ws/uninstall/",
        "status_endpoint": "/firefox/firefox/status/",
        "icon_name": "firefox.png",
        "operating_system_id": 1,
        "softwarekey": "windows10FireFox",
        "status": "installing"
      }
    ]
  const [dataSoft,setDataSoft]=useState({
    data: [],
    loading: true,
    error: null,
  })
  useEffect(()=>{
    search_softwares()
  },[])
  const search_softwares = () => {
    // setLoadingCis(true)
    setDataSoft({
      data: dataSoft.data,
      loading: true,
      error: dataSoft.error,
    });
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/provisioning_softwares_status/host/" +
            cisSelected.hostid,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setDataSoft({
            data: data1,
            loading: false,
            error: dataSoft.error,
          });
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  function status_action(element){
    switch(element.status){
      case 'not_installed':
        return <Action
        disabled={false}
        origen="Azul"
        titulo={capitalizeFirstLetter(lang[languaje]['instalar'])}
        action={()=>{action_installar('install_software',element.softwarekey,element.id)}}
      />
      case 'uninstalling':
        return <Action
        disabled={true}
        origen="Azul"
        titulo={capitalizeFirstLetter(lang[languaje]['desistalando'])}
        action={()=>{}}
      />
      case 'installed':
        return <Action
        disabled={false}
        origen="Red"
        titulo={capitalizeFirstLetter(lang[languaje]['desinstalar'])}
        action={()=>{action_installar('uninstall_software',element.softwarekey,element.id)}}
      />
      case 'installing':
        return <Action
        disabled={true}
        origen="Azul"
        titulo={capitalizeFirstLetter(lang[languaje]['instalando'])}
        action={()=>{}}
      />
      case 'unknown':
        return <Action
        disabled={true}
        origen="Azul"
        titulo={'N/A'}
        action={()=>{}}
      />
      default: <></>
    }
  }
  const [appSelected,setAppSelected]=useState(0)
  const [loading,setLoading]=useState(false)
  const action_installar=(url,key,id)=>{
    const data={
      "hostid": cisSelected.hostid,
      "softwarekey": key
    }
    setAppSelected(id)
    setLoading(true)
    const fetchDataPost = async () => {
      
   try {
     // console.log(localStorage.getItem('access_token'))
     const response = await fetch(server.url+'/api/v1/cassia/'+url, {
       method: 'POST',  
       headers: {
           'Content-Type': 'application/json',
           Authorization: `Bearer ${localStorage.getItem('access_token')}`,
         },
       body: JSON.stringify(data),
     });
     if (response.ok) {
       
       const data1 = await response.json();
       setLoading(false)
       setAppSelected(0)
       handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['actionComplet'])),capitalizeFirstLetter((lang[languaje]['msgActCompl'])), true)
       search_softwares()
     } else {
       const data1 = await response.json();
         handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['errorActionComplet']),data1.detail, false)
         
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
          
      setLoading(false)
        // Manejo de errores
        
        console.error(error);
      }
    };

    fetchDataPost();
  }
  //   installed
  // installing
  // uninstalling
  // not_installed
  return (
    <>
      <div className="cont-app-list">
          <div className="compact-app-list">
          <section class='FlexContainer'>
                  {
                      (dataSoft.loading)?<div style={{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}><LoadSimple/></div>:
                      dataSoft.data.data.map((element,index)=>(
                      // dataApps.map((element,index)=>(
                          (<div className="cont-globe">
                            <div className="globe-info globe-info-install">
                                <div className="cont-logo-app">
                                <img
                     
                     src={"/iconos/appIcon/"+element.icon_name}
                     title="workstation"
                     alt="workstation"
                     name="workstation"
                     // ci_id={cisSelected.element_id}
                     // onClick={openCisAfectaModal}
                     className="iconAppLogo"
                   />
                                </div>
                                <div className="cont-info-app">
                                    <div className="block-info-app" style={{color:'var(--third-color)',fontSize:'var(--font-size-large)'}}>
                                        {element.name}
                                    </div>
                                    <div className="block-info-app" style={{color:'var(--txt-color)',fontSize:'var(--font-size-small)'}}>
                                        <div>{capitalizeFirstLetter(lang[languaje]['estatus'])}:</div>&nbsp;<div>{element.status}</div>
                                    </div>
                                    <div className="block-info-app">
                                        
                                        {(loading && appSelected==element.id)?<LoadSimple/>:
                                        status_action(element)}
                                    </div>
                                </div>
                            </div>
                          </div>)
                      ))
                  }
                      {dataSoft.loading == false && dataSoft.data.data.length == 0 ? (
        <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}</div>
      ) : (
        ""
      )}
                  </section>
          </div>
      </div>
    </>
  );
};

export default Instalaciones;
